import { createApp } from "vue";
import store from "./store";
import PublicProfile from "@/publicProfile/PublicProfile.vue";
import includes from "@/services/publicProfileIncludes";
import "@sass/widget.scss";

// initialize app
const app = createApp(PublicProfile);

// use store and router
app.use(store);

includes(app);

// mount app
app.mount("#public-profile");
